import { useEffect, useRef } from 'react';

type Options = {
  intervalMs?: number;
  enabled?: boolean;
};

/**
 * Re-run data loaders on an interval and when the tab becomes visible again.
 */
export function useLiveDataRefresh(onRefresh: () => void, { intervalMs = 30000, enabled = true }: Options = {}) {
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const run = () => onRefreshRef.current();

    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        run();
      }
    };

    document.addEventListener('visibilitychange', onVisibility);
    const intervalId = window.setInterval(run, intervalMs);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.clearInterval(intervalId);
    };
  }, [enabled, intervalMs]);
}
